// extracted by mini-css-extract-plugin
var _1 = "link-WwpPl";
var _2 = "row-vsQvj";
export { _1 as "link", _2 as "row" }
